import { SensibleNumber } from '../../common/SensibleNumber'
import { CashoutState } from '../Reducers'
import { CashoutAction, CashoutActionType } from './CashoutActions'

const INITIAL_STATE: CashoutState = {
	amount: SensibleNumber.from(0),
	submitted: false,
	submissionError: false,
	submissionSuccess: false,
	purchaseCountersLoading: true,
	purchaseCounters: {},
}

export const cashoutReducer = (state: CashoutState = INITIAL_STATE, action: CashoutAction): CashoutState => {
	switch (action.type) {
	case CashoutActionType.RESET_STATE:
		return { ...INITIAL_STATE }
	case CashoutActionType.SET_AMOUNT:
		return { ...state, amount: action.payload }
	case CashoutActionType.RECEIVE_CASHOUT_INFO:
		return { ...state, userCashoutInfo: action.payload }
	case CashoutActionType.SUBMIT_CASHOUT:
		return { ...state, submitted: true }
	case CashoutActionType.RECEIVE_CASHOUT_RESPONSE:
		return { ...state, submissionSuccess: action.payload, submissionError: !action.payload }
	case CashoutActionType.RECEIVE_PURCHASE_COUNTERS: {
		return {
			...state,
			purchaseCounters: action.payload,
			purchaseCountersLoading: false,
		}
	}
	case CashoutActionType.START_PRIZEOUT_REDEMPTION:
		return state
	default:
		// Assert never is used to ensure that every known cashout action is handled by the switch-case.
		const assertNever: never = action
		return state
	}
}
